import { useState } from 'react'

import { TableRow, Td } from 'Design/components/Table'

import APITokenOptions from './APITokenOptions'

export const APIRow = (props) => {
  const { row, rowProps, onEditToken } = props
  const [isHovered, setHovered] = useState(false)

  const handleMouseEnter = () => {
    setHovered(true)
  }

  const handleMouseLeave = () => {
    setHovered(false)
  }

  return (
    <TableRow {...rowProps} clickable onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {row.cells.map((cell) => {
        const { key, ...cellProps } = cell.getCellProps()

        return (
          <Td key={key} {...cellProps}>
            {cell.render('Cell', { isHovered })}
          </Td>
        )
      })}
      <Td>
        <APITokenOptions id={row.original.id} onEditToken={onEditToken} />
      </Td>
    </TableRow>
  )
}
